// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"CoachDashboardView__materialize-textarea___3Qd0k","modal-2463794813":"CoachDashboardView__modal-2463794813___11DHZ","container":"CoachDashboardView__container___1Kv8_","adaptContainer":"CoachDashboardView__adaptContainer___7p2L6","emptyScreens":"CoachDashboardView__emptyScreens___1INte","emptyImage":"CoachDashboardView__emptyImage___2rHyv","noDescFound":"CoachDashboardView__noDescFound___1_I8D"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CoachDashboardView/CoachDashboardView.scss
// module id = 1471
// module chunks = 0